"use client";

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectGroup,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { CardTitle, CardDescription } from "./ui/card";

type DateRangeProps = {
  dateRange: string;
  setDateRange: (dateRange: string) => void;
  useHeader?: boolean;
  customWidth?: string;
};

export function DateRange({
  dateRange,
  setDateRange,
  useHeader = false,
  customWidth,
}: DateRangeProps) {
  return (
    <div className={`flex flex-col ${useHeader ? "gap-5" : "gap-1"}`}>
      <div className="flex-shrink-0">
        <div className="flex w-full flex-row items-center gap-4">
          {!useHeader ? (
            <Label
              htmlFor="dateRange"
              className="text-sm font-bold text-neutral-800"
            >
              Date Range
              <span className="text-red-600">*</span>
            </Label>
          ) : (
            <div className="min-w-0 flex-1">
              <CardTitle className="leading-normal">Date Range</CardTitle>
              <CardDescription>
                Select the date range of the data covered
              </CardDescription>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex-row">
        <Select value={dateRange} onValueChange={setDateRange}>
          <SelectTrigger
            className="!min-h-[45px] !shadow-none"
            style={{ width: customWidth || "100%" }}
          >
            <SelectValue placeholder="Select Date Range" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectItem value="last_24_hours" className="!h-[35px]">
                Last 24 hours
              </SelectItem>
              <SelectItem value="last_seven_days">Last 7 days</SelectItem>
              <SelectItem value="last_thirty_days">Last 30 days</SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
